export default __webpack_public_path__ + "static/media/User.d14a35ca.svg";